import React, { useEffect } from "react";
import Banner from "../Home/Banner";
import Chicken from "../Home/Chicken";
import ReferalBanner from "../Home/ReferalBanner";
import Mutton from "../Home/Mutton";
import Nutritionalvalue from "../Home/Nutritionalvalue";
import Recipe from "../Home/Recipe";
import ReviewCarousel from "../Home/ReviewCarousel";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
import Combo from "../Combos/Combo";
import Banner1 from "../Home/Banner1"
import Categories from "../Home/Categories";
import Combo1 from "../Combos/Combo1";
import SeaFood from "../Home/SeaFood";
import Forzen from "../Home/Forzen";
import Blogs from "../Home/Blogs";
import Reviews from "./Reviews";
import Prawn from "../Home/Prawn";

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      {" "}
      <Header />
      {/* <Banner /> */}
      <Banner1/>
      <Categories/>
      <Combo/>
      {/* <Combo1/> */}
      <SeaFood/>
      <Chicken />
      <ReferalBanner />
      <Mutton />
      <Forzen/>
      <Prawn/>
      {/* <Blogs/> */}
      {/* <Nutritionalvalue /> */}
      {/* <Recipe /> */}
      {/* <ReviewCarousel /> */}
      <Reviews/>
      <Footer />
    </>
  );
};

export default Home;
